import { render, staticRenderFns } from "./AccountTransaction.vue?vue&type=template&id=857c06bc"
import script from "./AccountTransaction.vue?vue&type=script&lang=js"
export * from "./AccountTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports